export const settingsTranslationRU = {
  settings: {
    "title": "Настройки",
    'preferences': 'Предпочтения',
    "account": "Аккаунт"
  }
}